module.exports = "\n<div class=\"ui-ripple-ink\"></div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/UiRippleInk.vue
 ** module id = 41
 ** module chunks = 0
 **/